module.exports = __webpack_public_path__ + "img/food_recommendation.c0ee2fc1.png";